// Copyright © 2021 Move Closer
import { SizeMap } from '../../_composables';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const bootstrapInputSizeRegistry = {
    [SizeMap.Medium]: '--medium',
    [SizeMap.Large]: '--large'
};
